import { render, staticRenderFns } from "./DiscountTypeCreate.vue?vue&type=template&id=50c9b2f6"
import script from "../../../controllers/custom/discount_type/discount-type-create.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/discount_type/discount-type-create.js?vue&type=script&lang=js&external"
import style0 from "./DiscountTypeCreate.vue?vue&type=style&index=0&id=50c9b2f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports